import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-52f7bf15"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "map-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "map"
}, null, -1));
const _hoisted_3 = {
  class: "map-type-toggle"
};
const _hoisted_4 = {
  class: "search-box"
};
const _hoisted_5 = {
  class: "search-input-wrapper"
};
const _hoisted_6 = ["onKeydown"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [/*#__PURE__*/_createElementVNode("circle", {
  cx: "11",
  cy: "11",
  r: "8"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "m21 21-4.35-4.35"
})], -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [/*#__PURE__*/_createElementVNode("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /*#__PURE__*/_createElementVNode("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})], -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  key: 0,
  class: "search-results"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "result-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"
}), /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "10",
  r: "3"
})])], -1));
const _hoisted_14 = {
  class: "result-name"
};
const _hoisted_15 = {
  class: "result-type"
};
const _hoisted_16 = {
  key: 1,
  class: "search-results search-no-data"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-data-content"
}, [/*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#999",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [/*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M8 12h8"
})]), /*#__PURE__*/_createElementVNode("span", null, "暂无数据")], -1));
const _hoisted_18 = [_hoisted_17];
const _hoisted_19 = {
  class: "info-content"
};
const _hoisted_20 = {
  key: 0,
  class: "loading-spinner"
};
const _hoisted_21 = {
  key: 1
};
const _hoisted_22 = {
  key: 0,
  class: "content-info"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主材质：", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主管径：", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "地址：", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "起点编号：", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "起点经纬度：", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "终点编号：", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "终点经纬度：", -1));
const _hoisted_30 = {
  key: 1,
  class: "content-info"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备编号：", -1));
import { ref, onMounted, watch, nextTick, onBeforeUnmount, computed } from 'vue';
import { useStore } from 'vuex';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import axios from 'axios';
import { useRouter } from "vue-router";
import { weChatrequest } from '@/utils/request';
import stationPng from '@/assets/img/mapcz.png';
import stationPngOffline from '@/assets/img/mapcz-2.png';
import stationPngAlarm from '@/assets/img/mapcz-3.png';
import actuatorPng from '@/assets/img/mapzxq.png';
import actuatorPngOffline from '@/assets/img/mapzxq-2.png';
import actuatorPngAlarm from '@/assets/img/mapzxq-3.png';
import pressurePng from '@/assets/img/mapyl.png';
import pressurePngOffline from '@/assets/img/mapyl-2.png';
import pressurePngAlarm from '@/assets/img/mapyl-3.png';
import gasPng from '@/assets/img/mapkr.png';
import gasPngOffline from '@/assets/img/mapkr-2.png';
import gasPngAlarm from '@/assets/img/mapkr-3.png';
import guandingzhuPng from '@/assets/img/guandingzhu.png';
import guandingzhuPngOffline from '@/assets/img/guandingzhu-2.png';
import guandingzhuPngAlarm from '@/assets/img/guandingzhu-3.png';
import fajingPng from '@/assets/img/fajing.png';
import fajingPngOffline from '@/assets/img/fajing-2.png';
import fajingPngAlarm from '@/assets/img/fajing-3.png';
import czxielouPng from '@/assets/img/cz.png';
import czxielouPngOffline from '@/assets/img/cz-2.png';
import czxielouPngAlarm from '@/assets/img/cz-3.png';
import gasstationPng from '@/assets/img/mapjq.png';
import gasstationPngOffline from '@/assets/img/mapjq-2.png';
import gasstationPngAlarm from '@/assets/img/mapjq-3.png';
import jgytPng from '@/assets/img/jgyt.png';
import jgytPngOffline from '@/assets/img/jgyt-2.png';
import jgytPngAlarm from '@/assets/img/jgyt-3.png';
import dialogBg from '@/assets/img/dialog2.png';
import dialogBgOffline from '@/assets/img/dialog2-2.png';
import dialogBgAlarm from '@/assets/img/dialog2-3.png';

// 天地图密钥

export default {
  __name: 'index',
  setup(__props) {
    const TIANDITU_KEY = '0403d8f2e9d5ef556009bfa3d2127d04';
    const store = useStore();
    const router = useRouter();

    // 获取当前租户的地图配置
    const getTenantMapConfig = () => {
      const tenantInfos = store.state.common.userInfo?.tenantInfos || [];
      const savedTenantId = localStorage.getItem("tenantId");

      // 查找当前选中的租户
      let currentTenant = null;
      console.log(savedTenantId, 'savedTenantId==');
      if (savedTenantId != 'null' && savedTenantId) {
        currentTenant = tenantInfos.find(t => String(t.tenantId) === String(savedTenantId));
      } else {
        // 返回空就使用默认的泰戈的经纬度108.9915740   34.1430180
        currentTenant = {
          mapCenterLatitude: 34.1430180,
          mapCenterLongitude: 108.9915740,
          mapZoomLevel: 16
        };
      }
      console.log(currentTenant, 'currentTenant==');
      // 如果租户有地图配置且有效，使用租户配置
      return {
        center: [currentTenant.mapCenterLatitude, currentTenant.mapCenterLongitude],
        zoom: currentTenant.mapZoomLevel
      };
    };
    let map, tianditu_vec, tianditu_img, tianditu_cva, tianditu_cia, popup;
    const showDialog = ref(false);
    // 用于管理各类要素的图层组
    let markerLayers = {
      actuator: null,
      mapkr: null,
      guandingzhu: null,
      fajing: null,
      czxielou: null,
      pressure: null,
      station: null,
      gasstation: null,
      jgyt: null
    };
    const deviceType = ref('');
    const curDevice = ref(null);
    // 当前弹窗设备状态：online/offline/alarm，用于切换弹窗背景图
    const curDeviceStatus = ref('online');
    const dialogBgImage = computed(() => {
      if (curDeviceStatus.value === 'alarm') return dialogBgAlarm;
      if (curDeviceStatus.value === 'offline') return dialogBgOffline;
      return dialogBg;
    });
    const infoWindow = ref({
      show: false,
      actNum: "",
      propList: [],
      position: {
        lng: 0,
        lat: 0
      },
      loading: false,
      id: null
    });
    const infoWindow1 = ref({
      zhucaizhi: "",
      guanjin: "",
      jizhi: "",
      dizhi: "",
      jiekou: "",
      fushe: "",
      qdbh: "",
      qdjwd: "",
      zdbh: "",
      zdjwd: ""
    });
    const currentMapStyle = ref(1);
    // 图层控制状态
    const layerControl = ref({
      mapkr: true,
      // 标识桩泄露
      guandingzhu: true,
      // 地埋式泄漏
      fajing: true,
      // 阀井泄露
      czxielou: true,
      // 场站泄漏
      actuator: true,
      // 执行器
      station: true,
      // 工商业监测
      pressure: true,
      // 压力传感器
      gasstation: true,
      // 场站
      jgyt: true // 激光云台
    });
    // 设备统计数据
    const deviceStats = ref({
      actuator: {
        online: 0,
        total: 0
      },
      mapkr: {
        online: 0,
        total: 0
      },
      guandingzhu: {
        online: 0,
        total: 0
      },
      fajing: {
        online: 0,
        total: 0
      },
      czxielou: {
        online: 0,
        total: 0
      },
      pressure: {
        online: 0,
        total: 0
      },
      station: {
        online: 0,
        total: 0
      },
      gasstation: {
        online: 0,
        total: 0
      },
      jgyt: {
        online: 0,
        total: 0
      }
    });
    // 存储 loadDeviceData 函数的引用，以便在 toggleLayer 中调用
    let loadDeviceDataFn = null;

    // 定时器
    let dataRefreshTimer = null;

    // 搜索相关
    const searchKeyword = ref('');
    const searchResults = ref([]);
    const searchPerformed = ref(false);
    // 存储所有设备数据用于搜索
    let allDevices = [];

    // 获取设备类型名称
    const getDeviceTypeName = deviceType => {
      const typeNames = {
        1: '执行器',
        2: '场站泄漏',
        3: '阀井泄露',
        4: '地埋式泄漏',
        5: '标识桩泄露',
        6: '压力传感器',
        7: '工商业监测',
        8: '场站',
        9: '激光云台'
      };
      return typeNames[deviceType] || '未知设备';
    };

    // 搜索设备
    const handleSearch = () => {
      if (!searchKeyword.value.trim()) {
        searchResults.value = [];
        return;
      }
      const keyword = searchKeyword.value.toLowerCase().trim();
      searchPerformed.value = true;
      searchResults.value = allDevices.filter(device => {
        const deviceCode = (device.deviceCode || '').toLowerCase();
        return deviceCode.includes(keyword);
      }).slice(0, 10);
    };

    // 清空搜索
    const clearSearch = () => {
      searchKeyword.value = '';
      searchResults.value = [];
      searchPerformed.value = false;
    };

    // 定位设备
    const locateDevice = device => {
      if (device.latitude && device.longitude) {
        // 移动地图到设备位置
        map.setView([device.latitude, device.longitude], 18);
        // 触发设备点击事件，显示设备详情弹窗
        deviceType.value = getDeviceTypeStr(device.deviceType);
        infoWindow.value.loading = true;
        infoWindow.value.actNum = device.deviceCode || '';
        infoWindow.value.id = device.id || null;
        infoWindow.value.position = {
          lng: device.longitude,
          lat: device.latitude
        };
        infoWindow.value.propList = [];
        showDialog.value = true;
        nextTick(() => {
          popup.setLatLng([device.latitude, device.longitude]).setContent(document.getElementById('mapDialog')).openOn(map);
        });
        curDevice.value = device;
        const effectiveStatus = device.hasAlarm ? 2 : device.deviceStatus;
        const statusMap = {
          0: 'offline',
          1: 'online',
          2: 'alarm'
        };
        curDeviceStatus.value = statusMap[effectiveStatus] || 'online';
        weChatrequest({
          url: '/api/v1/map/device/detail',
          method: 'post',
          data: {
            deviceCode: device.deviceCode,
            vendorCode: device.vendorCode
          }
        }).then(res => {
          if (res.data) {
            infoWindow.value.propList = res.data.fields || [];
          }
          infoWindow.value.loading = false;
        }).catch(err => {
          infoWindow.value.loading = false;
          console.error('获取设备详情失败:', err);
        });

        // 清空搜索结果
        searchResults.value = [];
        searchPerformed.value = false;
      }
    };

    // 获取设备类型字符串
    const getDeviceTypeStr = deviceType => {
      const typeMap = {
        1: 'actuator',
        2: 'czxielou',
        3: 'fajing',
        4: 'gas',
        5: 'gasGuandingzhu',
        6: 'pressure',
        7: 'station',
        8: 'gasstation',
        9: 'jgyt'
      };
      return typeMap[deviceType] || 'actuator';
    };

    // 加载设备统计数据
    const loadDeviceStats = () => {
      weChatrequest({
        url: '/api/v1/map/device/status/stats',
        method: 'get'
      }).then(res => {
        if (res.data && res.data.deviceTypes) {
          // menuType 与图层类型映射关系
          const typeMapping = {
            1: 'actuator',
            // 执行器
            2: 'czxielou',
            // 场站泄漏
            3: 'fajing',
            // 阀井泄露
            4: 'mapkr',
            // 地埋式泄漏
            5: 'guandingzhu',
            // 标识桩泄露
            6: 'pressure',
            // 压力传感器
            7: 'station',
            // 工商业监测
            8: 'gasstation',
            // 场站
            9: 'jgyt' // 激光云台
          };

          // 遍历接口返回的设备类型数据
          res.data.deviceTypes.forEach(item => {
            const layerKey = typeMapping[item.menuType];
            if (layerKey && item.count) {
              deviceStats.value[layerKey] = {
                online: item.count.online,
                total: item.count.total
              };
            }
          });
        }
      }).catch(err => {
        console.error('获取设备统计失败:', err);
      });
    };

    // 启动定时器
    const startDataRefreshTimer = () => {
      // 清除已存在的定时器
      if (dataRefreshTimer) {
        clearInterval(dataRefreshTimer);
      }
      // 每10秒刷新一次数据
      dataRefreshTimer = setInterval(() => {
        if (loadDeviceDataFn) {
          loadDeviceDataFn();
        }
        loadDeviceStats();
      }, 10000);
    };

    // 停止定时器
    const stopDataRefreshTimer = () => {
      if (dataRefreshTimer) {
        clearInterval(dataRefreshTimer);
        dataRefreshTimer = null;
      }
    };

    // 图层控制切换方法
    const toggleLayer = layerType => {
      const layerGroup = markerLayers[layerType];
      if (!layerGroup) return;
      if (layerControl.value[layerType]) {
        layerGroup.addTo(map);
      } else {
        layerGroup.remove();
      }
      // 切换图层时重新加载设备数据
      if (loadDeviceDataFn) {
        loadDeviceDataFn();
      }
    };

    // 处理图层项点击事件
    const handleLayerItemClick = (layerType, event) => {
      // 如果点击的是 checkbox 或 label，不处理
      if (event.target.type === 'checkbox' || event.target.tagName === 'LABEL') {
        return;
      }
      // 切换图层控制状态
      layerControl.value[layerType] = !layerControl.value[layerType];
      // 触发图层切换
      toggleLayer(layerType);
    };
    // 设备跳转详情
    const goDetail = val => {
      console.log(val, '--设备类型', curDevice.value);
      if (val == 'pressure') {
        router.push(`/leakMonitor/pressureMonitor?actNum=${infoWindow.value.actNum}`);
      } else if (val == 'gas') {
        router.push(`/leakMonitor/dmakxLedger3?actNum=${infoWindow.value.actNum}`);
      } else if (val == 'gasGuandingzhu') {
        router.push(`/leakMonitor/gxankexin2?actNum=${infoWindow.value.actNum}`);
      } else if (val == 'fajing') {
        router.push(`/leakMonitor/fjankexin4?actNum=${infoWindow.value.actNum}`);
      } else if (val == 'actuator') {
        router.push(`/deviceRunData?actId=${curDevice.value.id}&actNum=${infoWindow.value.actNum}&areaId=&fromRunData=true`);
      } else if (val == 'station') {
        router.push(`/leakMonitor/gsyjc?actNum=${infoWindow.value.actNum}`);
      } else if (val == 'gasstation') {
        router.push(`/station?actNum=${infoWindow.value.actNum}`);
      } else if (val == 'czxielou') {
        router.push(`/leakMonitor/czxielou?actNum=${infoWindow.value.actNum}`);
      } else if (val == 'jgyt') {
        router.push(`/leakMonitor/jgytManage?actNum=${infoWindow.value.actNum}`);
      }
    };
    function setNormalMap() {
      currentMapStyle.value = 1;
      tianditu_img.remove();
      tianditu_cia.remove();
      tianditu_vec.addTo(map);
      tianditu_cva.addTo(map);
      // 应用浅蓝色滤镜
      setTimeout(() => {
        const tilePane = document.querySelector('.leaflet-tile-pane');
        if (tilePane) {
          tilePane.style.filter = 'saturate(1.3) hue-rotate(170deg) brightness(1.05)';
        }
      }, 100);
    }
    function setSatelliteMap() {
      currentMapStyle.value = 2;
      tianditu_vec.remove();
      tianditu_cva.remove();
      tianditu_img.addTo(map);
      tianditu_cia.addTo(map);
      // 移除滤镜
      setTimeout(() => {
        const tilePane = document.querySelector('.leaflet-tile-pane');
        if (tilePane) {
          tilePane.style.filter = 'none';
        }
      }, 100);
    }
    onMounted(() => {
      // 天地图图层URL模板
      const tiandituVecUrl = `https://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${TIANDITU_KEY}`;
      const tiandituImgUrl = `https://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${TIANDITU_KEY}`;
      const tiandituCvaUrl = `https://t0.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${TIANDITU_KEY}`;
      const tiandituCiaUrl = `https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=${TIANDITU_KEY}`;

      // 创建图层
      tianditu_vec = L.tileLayer(tiandituVecUrl, {
        maxZoom: 18,
        minZoom: 1,
        attribution: '天地图'
      });
      tianditu_img = L.tileLayer(tiandituImgUrl, {
        maxZoom: 18,
        minZoom: 1,
        attribution: '天地图'
      });
      tianditu_cva = L.tileLayer(tiandituCvaUrl, {
        maxZoom: 18,
        minZoom: 1,
        attribution: '天地图'
      });
      tianditu_cia = L.tileLayer(tiandituCiaUrl, {
        maxZoom: 18,
        minZoom: 1,
        attribution: '天地图'
      });

      // 创建图标
      const icons = {
        station: {
          online: L.icon({
            iconUrl: stationPng,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          offline: L.icon({
            iconUrl: stationPngOffline,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          alarm: L.icon({
            iconUrl: stationPngAlarm,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          })
        },
        actuator: {
          online: L.icon({
            iconUrl: actuatorPng,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          offline: L.icon({
            iconUrl: actuatorPngOffline,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          alarm: L.icon({
            iconUrl: actuatorPngAlarm,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          })
        },
        pressure: {
          online: L.icon({
            iconUrl: pressurePng,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          offline: L.icon({
            iconUrl: pressurePngOffline,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          alarm: L.icon({
            iconUrl: pressurePngAlarm,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          })
        },
        gas: {
          online: L.icon({
            iconUrl: gasPng,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          offline: L.icon({
            iconUrl: gasPngOffline,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          alarm: L.icon({
            iconUrl: gasPngAlarm,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          })
        },
        gasGuandingzhu: {
          online: L.icon({
            iconUrl: guandingzhuPng,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          offline: L.icon({
            iconUrl: guandingzhuPngOffline,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          alarm: L.icon({
            iconUrl: guandingzhuPngAlarm,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          })
        },
        fajing: {
          online: L.icon({
            iconUrl: fajingPng,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          offline: L.icon({
            iconUrl: fajingPngOffline,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          alarm: L.icon({
            iconUrl: fajingPngAlarm,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          })
        },
        czxielou: {
          online: L.icon({
            iconUrl: czxielouPng,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          offline: L.icon({
            iconUrl: czxielouPngOffline,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          alarm: L.icon({
            iconUrl: czxielouPngAlarm,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          })
        },
        gasstation: {
          online: L.icon({
            iconUrl: gasstationPng,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          offline: L.icon({
            iconUrl: gasstationPngOffline,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          alarm: L.icon({
            iconUrl: gasstationPngAlarm,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          })
        },
        jgyt: {
          online: L.icon({
            iconUrl: jgytPng,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          offline: L.icon({
            iconUrl: jgytPngOffline,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          }),
          alarm: L.icon({
            iconUrl: jgytPngAlarm,
            iconSize: [25, 25],
            iconAnchor: [12, 12]
          })
        }
      };

      // 根据设备状态和设备子类型获取图标
      const getIconByStatus = (deviceType, deviceStatus, deviceSubType) => {
        console.log(deviceType, 'deviceType***********888');
        const statusMap = {
          0: 'offline',
          // 离线
          1: 'online',
          // 在线
          2: 'alarm' // 告警
        };
        const status = statusMap[deviceStatus] || 'offline';
        return icons[deviceType][status];
      };

      // 初始化地图，使用租户配置或默认配置
      const mapConfig = getTenantMapConfig();
      map = L.map('map', {
        center: mapConfig.center,
        zoom: mapConfig.zoom,
        zoomControl: true,
        layers: [tianditu_vec, tianditu_cva]
      });

      // 初始化时应用浅蓝色滤镜（默认显示普通地图）
      setTimeout(() => {
        const tilePane = document.querySelector('.leaflet-tile-pane');
        if (tilePane) {
          tilePane.style.filter = 'saturate(1.3) hue-rotate(170deg) brightness(1.05)';
        }
      }, 100);

      // 创建弹窗
      popup = L.popup({
        maxWidth: 300,
        closeButton: false
      });

      // 创建业务图层组
      markerLayers.actuator = L.layerGroup();
      markerLayers.mapkr = L.layerGroup();
      markerLayers.guandingzhu = L.layerGroup();
      markerLayers.fajing = L.layerGroup();
      markerLayers.czxielou = L.layerGroup();
      markerLayers.pressure = L.layerGroup();
      markerLayers.station = L.layerGroup();
      markerLayers.gasstation = L.layerGroup();
      markerLayers.jgyt = L.layerGroup();

      // 获取设备列表数据
      loadDeviceDataFn = () => {
        // 根据复选框状态构建 deviceTypeList
        const deviceTypeList = [];
        if (layerControl.value.actuator) deviceTypeList.push(1); // 执行器
        if (layerControl.value.czxielou) deviceTypeList.push(2); // 场站泄漏
        if (layerControl.value.fajing) deviceTypeList.push(3); // 阀井泄露
        if (layerControl.value.mapkr) deviceTypeList.push(4); // 地埋式泄漏
        if (layerControl.value.guandingzhu) deviceTypeList.push(5); // 标识桩泄露
        if (layerControl.value.pressure) deviceTypeList.push(6); // 压力传感器
        if (layerControl.value.station) deviceTypeList.push(7); // 工商业监测
        if (layerControl.value.jgyt) deviceTypeList.push(9); // 激光云台

        const params = {
          deviceTypeList: deviceTypeList,
          tenantId: localStorage.getItem("tenantId")
        };
        weChatrequest({
          url: '/api/v1/map/device/list',
          method: 'post',
          data: params
        }).then(res => {
          if (res.data && Array.isArray(res.data)) {
            // 保存所有设备数据用于搜索
            allDevices = res.data;
            // 清空现有标记
            Object.keys(markerLayers).forEach(key => {
              if (markerLayers[key]) {
                markerLayers[key].clearLayers();
              }
            });
            // 根据设备类型分类数据
            const deviceMap = {
              actuator: [],
              mapkr: [],
              guandingzhu: [],
              fajing: [],
              czxielou: [],
              pressure: [],
              station: [],
              gasstation: [],
              jgyt: []
            };
            res.data.forEach(device => {
              const deviceType = device.deviceType;
              if (deviceType == 1) {
                deviceMap.actuator.push(device);
              } else if (deviceType == 2) {
                deviceMap.czxielou.push(device);
              } else if (deviceType == 3) {
                deviceMap.fajing.push(device);
              } else if (deviceType == 4) {
                deviceMap.mapkr.push(device);
              } else if (deviceType == 5) {
                deviceMap.guandingzhu.push(device);
              } else if (deviceType == 6) {
                deviceMap.pressure.push(device);
              } else if (deviceType === 7) {
                deviceMap.station.push(device);
              } else if (deviceType === 8) {
                deviceMap.gasstation.push(device);
              } else if (deviceType === 9) {
                deviceMap.jgyt.push(device);
              }
            });
            const createMarker = (device, deviceTypeStr) => {
              if (!device.latitude || !device.longitude) return null; //经纬度不存在不渲染

              // 如果 hasAlarm 为 true，则强制使用告警状态的图标
              const effectiveDeviceStatus = device.hasAlarm ? 2 : device.deviceStatus;
              const icon = getIconByStatus(deviceTypeStr, effectiveDeviceStatus, device.deviceSubType);
              const m = L.marker([device.latitude, device.longitude], {
                icon
              });

              // 为告警状态的设备添加闪烁效果
              if (device.hasAlarm) {
                m.on('add', function () {
                  setTimeout(() => {
                    const iconEl = this.getElement();
                    if (iconEl) {
                      iconEl.classList.add('alarm-blink');
                    }
                  }, 0);
                });
              }
              m.on('click', e => {
                deviceType.value = deviceTypeStr;
                infoWindow.value.loading = true;
                infoWindow.value.actNum = device.deviceCode || '';
                infoWindow.value.id = device.id || null;
                infoWindow.value.position = {
                  lng: device.longitude,
                  lat: device.latitude
                };
                infoWindow.value.propList = [];
                showDialog.value = true;
                nextTick(() => {
                  popup.setLatLng(e.latlng).setContent(document.getElementById('mapDialog')).openOn(map);
                });
                curDevice.value = device;
                // 根据设备状态设置弹窗背景图
                const effectiveStatus = device.hasAlarm ? 2 : device.deviceStatus;
                const statusMap = {
                  0: 'offline',
                  1: 'online',
                  2: 'alarm'
                };
                curDeviceStatus.value = statusMap[effectiveStatus] || 'online';
                // 查询设备详情接口
                weChatrequest({
                  url: '/api/v1/map/device/detail',
                  method: 'post',
                  data: {
                    deviceCode: device.deviceCode,
                    vendorCode: device.vendorCode
                  }
                }).then(res => {
                  if (res.data) {
                    infoWindow.value.propList = res.data.fields || [];
                  }
                  infoWindow.value.loading = false;
                }).catch(err => {
                  infoWindow.value.loading = false;
                  console.error('获取设备列表失败:', err);
                });
              });
              return m;
            };

            // 为每种设备类型创建标记
            deviceMap.actuator.forEach(device => {
              const marker = createMarker(device, 'actuator');
              if (marker) markerLayers.actuator.addLayer(marker);
            });
            deviceMap.mapkr.forEach(device => {
              const marker = createMarker(device, 'gas');
              if (marker) markerLayers.mapkr.addLayer(marker);
            });
            deviceMap.guandingzhu.forEach(device => {
              const marker = createMarker(device, 'gasGuandingzhu');
              if (marker) markerLayers.guandingzhu.addLayer(marker);
            });
            deviceMap.fajing.forEach(device => {
              const marker = createMarker(device, 'fajing');
              if (marker) markerLayers.fajing.addLayer(marker);
            });
            deviceMap.czxielou.forEach(device => {
              const marker = createMarker(device, 'czxielou');
              if (marker) markerLayers.czxielou.addLayer(marker);
            });
            deviceMap.pressure.forEach(device => {
              const marker = createMarker(device, 'pressure');
              if (marker) markerLayers.pressure.addLayer(marker);
            });
            deviceMap.station.forEach(device => {
              const marker = createMarker(device, 'station');
              if (marker) markerLayers.station.addLayer(marker);
            });
            deviceMap.gasstation.forEach(device => {
              const marker = createMarker(device, 'gasstation');
              if (marker) markerLayers.gasstation.addLayer(marker);
            });
            deviceMap.jgyt.forEach(device => {
              const marker = createMarker(device, 'jgyt');
              if (marker) markerLayers.jgyt.addLayer(marker);
            });

            // 根据图层控制状态显示/隐藏
            Object.keys(markerLayers).forEach(key => {
              if (layerControl.value[key] && markerLayers[key]) {
                markerLayers[key].addTo(map);
              } else if (markerLayers[key]) {
                markerLayers[key].remove();
              }
            });
          }
        }).catch(err => {
          console.error('获取设备列表失败:', err);
        });
      };
      // 初始化完成后加载设备数据
      loadDeviceDataFn();
      // 加载设备统计数据
      loadDeviceStats();
      // 启动定时器
      startDataRefreshTimer();
    });

    // 组件卸载时清除定时器
    onBeforeUnmount(() => {
      stopDataRefreshTimer();
      if (map) {
        map.remove();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
        id: "map-blend-layer",
        class: _normalizeClass(["map-blend-layer", {
          active: currentMapStyle.value === 1
        }])
      }, null, 2), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
        class: _normalizeClass({
          active: currentMapStyle.value === 1
        }),
        onClick: setNormalMap
      }, "普通", 2), _createElementVNode("button", {
        class: _normalizeClass({
          active: currentMapStyle.value === 2
        }),
        onClick: setSatelliteMap
      }, "卫星", 2)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
        placeholder: "请输入设备编号搜索",
        onKeydown: _withKeys(_withModifiers(handleSearch, ["prevent"]), ["enter"]),
        class: "search-input"
      }, null, 40, _hoisted_6), [[_vModelText, searchKeyword.value]]), _createElementVNode("button", {
        class: "search-btn",
        onClick: handleSearch
      }, _hoisted_8), searchKeyword.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "clear-btn",
        onClick: clearSearch
      }, _hoisted_10)) : _createCommentVNode("", true)]), searchResults.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (result, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "search-result-item",
          onClick: $event => locateDevice(result)
        }, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(result.deviceCode), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(getDeviceTypeName(result.deviceType)), 1), _createElementVNode("span", {
          class: _normalizeClass(['result-status', result.deviceStatus === 1 ? 'online' : 'offline'])
        }, _toDisplayString(result.deviceStatus === 1 ? '在线' : '离线'), 3)], 8, _hoisted_12);
      }), 128))])) : _createCommentVNode("", true), searchPerformed.value && searchResults.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18)) : _createCommentVNode("", true)]), showDialog.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "mapDialog",
        class: _normalizeClass(["custom-info-window", ['dialog-status-' + curDeviceStatus.value]]),
        style: _normalizeStyle({
          backgroundImage: `url(${_unref(dialogBgImage)})`
        })
      }, [_createElementVNode("div", _hoisted_19, [infoWindow.value.loading ? (_openBlock(), _createElementBlock("div", _hoisted_20)) : (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("p", {
        class: "title",
        onClick: _cache[1] || (_cache[1] = $event => goDetail(deviceType.value))
      }, "设备信息"), deviceType.value == 'guanxian' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("p", null, [_hoisted_23, _createTextVNode(_toDisplayString(infoWindow1.value.zhucaizhi || '-'), 1)]), _createElementVNode("p", null, [_hoisted_24, _createTextVNode(_toDisplayString(infoWindow1.value.guanjin || '-'), 1)]), _createElementVNode("p", null, [_hoisted_25, _createTextVNode(_toDisplayString(infoWindow1.value.dizhi || '-'), 1)]), _createElementVNode("p", null, [_hoisted_26, _createTextVNode(_toDisplayString(infoWindow1.value.qdbh || '-'), 1)]), _createElementVNode("p", null, [_hoisted_27, _createTextVNode(_toDisplayString(infoWindow1.value.qdjwd || '-'), 1)]), _createElementVNode("p", null, [_hoisted_28, _createTextVNode(_toDisplayString(infoWindow1.value.zdbh || '-'), 1)]), _createElementVNode("p", null, [_hoisted_29, _createTextVNode(_toDisplayString(infoWindow1.value.zdjwd || '-'), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("p", null, [_hoisted_31, _createTextVNode(_toDisplayString(infoWindow.value.actNum), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(infoWindow.value.propList, item => {
        return _openBlock(), _createElementBlock("p", null, [_createElementVNode("span", null, _toDisplayString(item.label) + ":", 1), _createTextVNode(_toDisplayString(item.value), 1)]);
      }), 256))]))]))])], 6)) : _createCommentVNode("", true)]);
    };
  }
};